import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import api from '../../api/index';

export const getGroupsByGame = createAsyncThunk(
  'dashboard/getGroupsByGame',
  async (gameId, thunkAPI) => {
    const response = await api.getGroupsByGame(gameId);
    return response.data;
  }
);

export const getGroupsStatus = createAsyncThunk(
  'dashboard/getGroupsStatus',
  async (gameId, thunkAPI) => {
    const response = await api.getGroupsStatus(gameId);
    return response.data;
  }
);

export const getGroupsStatusTest = createAsyncThunk(
  'dashboard/getGroupsStatus',
  async (gameId, thunkAPI) => {
    const response = await api.getGroupsStatusTest(gameId);
    return response.data;
  }
);

export const stopGame = createAsyncThunk(
  "game/stopGame",
  async (gameId, thunkAPI) => {
      const response = await api.stopGame(gameId);
      return response.data;
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: { userCount:0, joinedUsers: 0, users: [], groups: [], groupStatus: [] },
  reducers: {
  },
  extraReducers: {
    [getGroupsByGame.fulfilled] : (state, { payload }) => {
      state.groups = payload;
    },
    [getGroupsStatus.fulfilled] : (state, { payload }) => {
      let groupsOldState = current(state.groupStatus);
      let groupsNewState = payload;
      if(groupsOldState) {
        groupsNewState.forEach((groupNewState, index) => {
          let groupOldState = _.find(groupsOldState, {group_id: groupNewState.group_id});

          if(groupOldState){
            groupNewState.oldRank = groupOldState.rank;
            groupNewState.oldScore = groupOldState.score;
          }
        });
      }
      
      state.groupStatus = groupsNewState;
    },
  }
});

export const { userJoined } = dashboardSlice.actions;

export default dashboardSlice.reducer;